module.exports = __webpack_public_path__ + "static/img/weixin.c2310c40.png";